import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import axios from "axios";
import routes from "./routes/routes";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment";
import GAuth from "vue-google-oauth2";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

Vue.use(VueRouter);
Vue.use(VueSweetalert2);

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY hh:mm:ss A");
  }
});

const gauthOption = {
  clientId:
    "990184155144-22mks332a49cul113nfb1vgt4ot11sek.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "consent",
  fetch_basic_profile: true,
};
Vue.use(GAuth, gauthOption);

Vue.prototype.$config = require("./api/config.json");
Vue.prototype.$minHeight = "600px";
// if(location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
//   Vue.prototype.$base = 'http://localhost:8082/#'
//   Vue.prototype.$api = 'http://localhost:8000/'
// }
// else {
Vue.prototype.$base = "https://geekbuyback.com/#";
Vue.prototype.$api = "https://geekbuyback.com/admin/";
// }

const router = new VueRouter({
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkActiveClass: "active",
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
